import React from 'react';

export const AudioCallSuccessSvg = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 171 171"
      width="23px"
      height="23px"
    >
      <g
        style={{ mixBlendMode: 'normal' }}
        fill="none"
        strokeMiterlimit="10"
        fontFamily="none"
        fontSize="none"
        fontWeight="none"
        textAnchor="none"
      >
        <path d="M0,171.99374v-171.99374h171.99374v171.99374z" />
        <path
          fill="#26de81"
          d="M2.63848,85.5c0,-45.75586 37.10566,-82.86152 82.86152,-82.86152c45.75586,0 82.86152,37.10566 82.86152,82.86152c0,45.75586 -37.10566,82.86152 -82.86152,82.86152c-45.75586,0 -82.86152,-37.10566 -82.86152,-82.86152z"
        />
        <path
          fill="#fcc288"
          d="M133.79414,85.23281c-1.03535,-1.30254 -1.83691,-1.83691 -2.1041,-3.13945c2.1041,-1.03535 4.2082,-5.24355 4.2082,-6.57949c-0.26719,-8.91738 -8.68359,-10.7543 -8.68359,-10.7543c0,0 0,0 -25.21582,0c-1.83691,-0.26719 -0.53438,-5.24355 0.53437,-7.08047c4.47539,-7.88203 7.08047,-14.9625 7.08047,-18.66973c-1.56973,-18.13535 -13.92715,-14.9625 -14.46152,-13.12559c-0.26719,18.40254 -4.47539,22.57734 -9.18457,25.7502c-4.74258,3.13945 -5.24355,6.81328 -10.7543,19.43789c-5.51074,12.62461 -15.76406,8.41641 -15.76406,8.41641c0,0 0.26719,3.94102 0.26719,40.97988c30.99375,5.77793 48.59473,5.00977 56.74395,4.2082c8.14922,-0.76816 10.7877,-6.3123 10.7877,-9.18457c0,-3.40664 1.03535,-5.24355 2.37129,-6.04512c5.77793,-4.74258 3.94102,-6.3123 2.37129,-9.71895c-1.56973,-3.40664 -1.03535,-4.47539 1.56973,-6.84668c3.07266,-2.67187 1.30254,-6.3457 0.23379,-7.64824z"
        />
        <path
          fill="#5c524a"
          d="M58.14668,78.11895h-15.99785c-0.86836,0 -1.56973,0.70137 -1.56973,1.60313v41.74805c0,0.86836 0.70137,1.60313 1.56973,1.60313h15.99785c0.86836,0 1.56973,-0.70137 1.56973,-1.60313v-41.74805c0,-0.90176 -0.70137,-1.60313 -1.56973,-1.60313z"
        />
      </g>
    </svg>
  );
};
